import React, { createContext, useState, useEffect } from 'react';
// import frame from "../Assets/img/upload-image.png";
import useApi from './Utilities/useAPI';
// Create a Context
export const ContactsDetContext = createContext();

// Create a Provider component
export const ContactsDetProvider = ({ children }) => {
  const [groupDetails, setGroupDetails] = useState({
    group_name: '',
    group_type: "CONTACT",
    group_category: "CONTACT",
    group_subname: '',
    group_desc: '',
    group_image: '',
    members: [],
    admins: [],
  });

  const resetGroupDetails = () => {
    setGroupDetails({
      group_name: '',
      group_type: 'CONTACT',
      group_category: 'CONTACT',
      group_subname: '',
      group_desc: '',
      group_image: '',
      members: [],
      admins: [],
    });
  };

  const [groupDetailsEdit, setGroupDetailsEdit] = useState({
    group_name: '',
    group_type: "CONTACT",
    group_category: "CONTACT",
    group_subname: '',
    group_desc: '',
    group_image: '',
    members: [],
    admins: [],
    edit: true
  });

  const { callApiFunction } = useApi();

  const [ConnectedContacts, setConnectedContacts] = useState([]);
  const [unVerifiedCount, setUnVerifedCount] = useState([]);
  const [UnverifiedContacts, setUnverifiedContacts] = useState([]);
  const [groupsAll, setGroupsAll] = useState([]);
  const [favouriteContacts, setFavoriteContacts] = useState([]);
  const [CardConnectMember, setCardConnectMember] = useState({});

  const formatGroupsData = (data) => {

    const groupNames = Object.keys(data);


    // Initialize an empty object to store the formatted data
    const formattedGroups = {};

    groupNames.forEach((groupName) => {
      const members = data[groupName];
      console.log("Conte ni the context", members);
      if (members?.length > 0) {
        formattedGroups[groupName] = members.map((member) => ({
          img: member.card_details?.profile_url || "",
          name: `${member.first_name} ${member.last_name}`,
          contact_ref_id: member.reference_id,
          role: "FRIEND",
          email: member.card_details?.card_email,
          phone_no: member?.card_details?.card_mobile?.replace(/[\s-]/g, ''),
          verified: true,
          isfavourite: false
        }));
      }
      console.log("Member data", members);
    });

    return formattedGroups;
  };

  useEffect(() => {
    // Fetch contacts from the API
    const fetchContacts = async () => {
      // try {
      //   const response = await callApiFunction('ConnectedContacts');

      //   const data = response;
      //   if (data.statusCode === 200) {
      //     const members = data.data.map(member => {
      //       // Logic for role and subTitle
      //       const role = member.designation || member.field_of_study || member.title || '---';  // Updated role logic
      //       const subTitle = member.profession_department || member.institute || member.nickname || '---';  // New subTitle logic

      //       return {
      //         id: member.id,
      //         contact_ref_id: member.contact_ref_id,
      //         img: member.profile_url,  // Fallback to default image if profile URL is null
      //         is_favourite: member?.is_favourite ? true : false,
      //         name: `${member.first_name} ${member.last_name}`,
      //         role: role,  // Based on new logic
      //         email: `${member.first_name.toLowerCase()}.${member.last_name.toLowerCase()}@example.com`,  // Mock email as it's not provided
      //         verified: member.is_verified ? true : false,
      //         neoin_id: member.unique_id,
      //         subTitle: subTitle  // Add new subTitle field
      //       };
      //     });
      //     setConnectedContacts(members)

      //     const unverifiedMembers = members.filter(member => !member.verified);
      //     setUnverifiedContacts(unverifiedMembers);
      //     setUnVerifedCount(unverifiedMembers.length);

      //     // Filter and set favorite contacts
      //     const favoriteMembers = members.filter(member => member.is_favourite);
      //     setFavoriteContacts(favoriteMembers);
      //   }
      // } catch (err) {
      //   console.log('An error occurred while sending the connection request:', err);
      // }

      // try {
      //   const response = await callApiFunction('fetchGroupDetails');

      //   if (response?.statusCode === 200) {
      //     // Map the response data to extract group name and URL
      //     const backendGroups = response.data.map(group => ({
      //       name: group.group_name,
      //       url: group.group_url,
      //       id: group.id,
      //       group_image: group.group_image,
      //       // persons: personsData,
      //       persons: group.members.map(member => ({
      //         img: member.profile_url, // Use a placeholder if profile_url is null
      //         name: `${member.first_name} ${member.last_name}`,
      //       })),
      //       count: group.count,
      //     }));

      //     setGroupsAll(backendGroups);
      //   } else {
      //     console.log('Error fetching groups:');
      //   }
      // } catch (error) {
      //   console.error('Error:', error);
      // }

      // try {
      //   const response = await callApiFunction('getConnectionsMethods');

      //   if (response?.statusCode === 200) {
      //     // Map the response data to extract group name and URL
      //     const formattedGroups = formatGroupsData(response.data);
      //     setCardConnectMember(formattedGroups);
      //     // console.log("cardConnected Members", CardConnectMember);
      //     console.log("Connection Methds", response);
      //   } else {
      //     console.log('Error fetching groups:');
      //   }
      // } catch (error) {
      //   console.error('Error:', error);
      // }

    };

    fetchContacts();
  }, []);

  return (
    <ContactsDetContext.Provider value={{
      unVerifiedCount, setUnVerifedCount, UnverifiedContacts, setUnverifiedContacts, resetGroupDetails,
      groupDetails, setGroupDetails, ConnectedContacts, groupDetailsEdit, setGroupDetailsEdit,
      groupsAll, CardConnectMember, favouriteContacts
    }}>
      {children}
    </ContactsDetContext.Provider>
  );
};
